
import './side.css';

export const Side = ()=>{
    return(<>
        <div className='sidde'>
            <img 
                className='logo'
                alt='logo'
                src='data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgNDAgMjAiIHdpZHRoPSI0MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Im0xMi4yMjk5IDE0LjI0MDJjLS4zODMyLS42MDU1LS42OTY4LS45MjYtMS4yNTQzLS45MjZzLS44NzExLjMyMDUtMS4yNTQzNi45MjZsLTEuNjcyNDcgMi42NzEzYy0uNjI3MTggMS4wMzI5LTEuMTQ5ODMgMS43NDUzLTIuMzY5MzQgMS43NDUzcy0xLjc3Ny0uNDk4Ny0yLjM2OTMzLTEuODg3OGMtLjczMTcxLTEuNzA5Ni0xLjQ5ODI2LTMuNzc1NC0yLjE5NTEyLTYuNTUzNi0uNzY2NTQ5LTMuMDk5MjUtMS4xMTQ5OC01LjAyMjU5LTEuMTE0OTgtNi41ODk3NnMuNDg3ODA0LTIuNDkzMjIgMi4xNjAyNy0yLjgxMzc3N2MyLjI5OTY1LS40Mjc0MDkgNS40MDA2OS0uNjc2NzMxIDguODE1MzMtLjY3NjczMSAzLjQxNDYgMCA2LjUxNTcuMjQ5MzIyIDguODE1My42NzY3MzEgMS42NzI1LjMyMDU1NyAyLjE2MDMgMS4yNDY2MDcgMi4xNjAzIDIuODEzNzc3cy0uMzQ4NCAzLjQ5MDUxLTEuMTE1IDYuNTg5NzZjLS42OTY5IDIuNzc4Mi0xLjQ2MzQgNC44NDQtMi4xOTUxIDYuNTUzNi0uNTkyNCAxLjM4OTEtMS4xNDk4IDEuODg3OC0yLjM2OTQgMS44ODc4LTEuMjE5NSAwLTEuNzQyMS0uNzEyNC0yLjM2OTMtMS43NDUzem0yNi41MTU4IDIuNDk5OWMtMS4xODQ3IDEuMjgyMi0zLjQxNDcgMi4yMDgzLTYuMzQxNSAyLjIwODMtNS44ODg1IDAtOS4zNzI4LTQuMDk2LTkuMzcyOC05LjQ3NDI0IDAtNS43NzAwMyA0LjAwNjktOS4xODkzMDEgOS4xOTg2LTkuMTg5MzAxIDQuNjM0MiAwIDcuNzAwNCAyLjQ1NzYwMSA3LjcwMDQgNS43NzAwMzEgMCAzLjEzNDMzLTIuNjEzMyA1LjE2NDUxLTUuNTc1IDUuMTY0NTEtMS42MDI4IDAtMi43ODc0LS4zMjA1LTMuNTg4OC0uOTYxNy0uMzEzNi0uMjQ5My0uNDg3OC0uMjEzNy0uNDg3OC4wNzEzIDAgMS4xNzU0LjQxODEgMi4xNzI2IDEuMTg0NiAyLjk1NjIuNjI3Mi42NDExIDEuODExOSAxLjA2ODYgMi45MjY5IDEuMDY4NiAxLjE0OTggMCAyLjE2MDMtLjI0OTQgMy4wNjYyLS43MTI0czEuNjcyNS0uMzIwNiAyLjEyNTQuNDI3NGMuNTIyNy44NTQ4LS4yMDkgMS45NTktLjgzNjIgMi42NzEzeiIgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+'
            />
            

                <section className='wwwwllll'>
                    
                        <div className="wt-product-header">
                            <h1 className="wt-product-header__header hh111" id="wt-product-header-line">
                                The simplest way to share 
                                &#160;
                                <span className="wt-product-header__header--strong str">big ideas</span>
                            </h1>

                            <h3 className="wt-product-header__subheader hhh333" id="wt-product-subheader-line">
                                Send files on your terms with WeTransfer
                            </h3>
                        </div>

                        <div className='wt-product-feature__image-wrapper bimg' id='wt-product-feature-wrapper'>
                            {/* <img 
                                className='wt-product-feature__image bgrd_jghLkjhjKjjhkl'
                                alt='Add Your Files'
                                title='Add your files'
                                id='immm'
                                // src={bgrdd}
                            /> */}
                        </div>

                </section>

        </div>
    </>);
};